import {
  CardPage,
  getTranslatedText,
  HeaderTag,
  withErrorBoundary,
  AccessControl
} from '@nile/components';
import { Button, Modal, Page } from '@superops/ui-design-system';
import MonitoredAssetListNew from '@nile/rmm/src/modules/it-documentation/components/sub-pages/monitored-asset-list/monitor-asset-list-new';
import React, { useCallback, useState } from 'react';
import { SVGIcon } from '@superops/super-icons';
import AssociatedAssetSheet from '@nile/rmm/src/modules/it-documentation/components/sub-pages/associated-asset-sheet/index';

function AssociateMonitorAsset(props) {
  const { assetId, intl, clientName, siteName } = props;
  const [associatedSheetActive, setAssociatedSheetActive] = useState(false);
  const [isRenderMonitoredAssets, setIsRenderMonitoredAssets] = useState(false);
  const toggleAssociateAsset = useCallback(() => {
    setAssociatedSheetActive((prev) => !prev);
  });
  const isRefetchMonitorAsset = () => {
    setIsRenderMonitoredAssets((prev) => !prev);
  };
  return (
    <div
      className="f11 no-scroll white-bg br10 min-height-320 white-grey-page"
      key={assetId}
    >
      <Page
        divider
        title={
          <HeaderTag
            noMargin
            isNewLayout
            title={getTranslatedText(intl, 'asset.details.associated.assets')}
          />
        }
        variant="secondary"
        contentHeight="100px"
        primaryAction={
          <AccessControl
            roleToCheck="itDocumentation.edit"
            render={
              <Button
                id="itAssociateAssets"
                icon={<SVGIcon name="Add" size="sm" />}
                onClick={toggleAssociateAsset}
              >
                {getTranslatedText(intl, 'asset.details.itDoc.associate')}
              </Button>
            }
          />
        }
      >
        <Modal
          open={associatedSheetActive}
          onClose={toggleAssociateAsset}
          large
          titleHidden
          title=""
          showCloseButton={false}
        >
          <AssociatedAssetSheet
            assetId={assetId}
            entityName="Asset"
            toggleSheet={toggleAssociateAsset}
            isRefetchMonitorAsset={isRefetchMonitorAsset}
            clientName={clientName}
            siteName={siteName}
          />
        </Modal>
        <div className="mb20">
          <MonitoredAssetListNew
            isRenderMonitoredAssets={isRenderMonitoredAssets}
            entityName="IPAsset"
          />
        </div>
      </Page>
    </div>
  );
}
export default withErrorBoundary(AssociateMonitorAsset);
